import script from "./PaymentStatusView.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentStatusView.vue?vue&type=script&setup=true&lang=js"

import "./PaymentStatusView.vue?vue&type=style&index=0&id=661508ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-661508ea"]])

export default __exports__